// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2CoC6","obliqueLineWrap":"membershipbadge_obliqueLineWrap__E9m4b","obliqueLine":"membershipbadge_obliqueLine__yhRai"};